export const PaymentActionTypes = {
  FETCH_INFO: '@@payment/FETCH_INFO',
  FETCH_INFO_SUCCESS: '@@payment/FETCH_INFO_SUCCESS',
  FETCH_INFO_ERROR: '@@payment/FETCH_INFO_ERROR',
};
